import navBarClasses from "../assets/styles/appShell.module.css";

import { NavLink } from "@mantine/core";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface LeftNavbarLinkProps {
  title: string;
  href: string;
  activeRoutes: string[];
  icon: JSX.Element;
}

const LeftNavbarLink: React.FC<LeftNavbarLinkProps> = ({
  title,
  href,
  icon,
  activeRoutes,
}) => {
  const navigate = useNavigate();
  const activeIconColor = "#7033FC";
  const inactiveIconColor = "#A9A0B2";
  const location = useLocation();
  let isActive = false;
  for (const route of activeRoutes) {
    if (route === location.pathname) {
      isActive = true;
    } else if (route.endsWith("*")) {
      if (location.pathname.startsWith(route.slice(0, -1))) {
        isActive = true;
      }
    }
  }

  const cssClasses = [navBarClasses.navTitle];
  if (isActive) {
    cssClasses.push(navBarClasses.activeNavTitle);
  } else {
    cssClasses.push(navBarClasses.inactiveNavTitle);
  }

  return (
    <NavLink
      label={<span className={cssClasses.join(" ")}>{title}</span>}
      onClick={() => navigate(href)}
      leftSection={React.cloneElement(icon, {
        color: isActive ? activeIconColor : inactiveIconColor,
      })}
    />
  );
};

export default LeftNavbarLink;
